import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel } from '@angular/material/select';

export interface SupportPortalDialogData {
  title: string;
  supraSupportPortalLink: string;
  description: string;
}

@Component({
    selector: 'app-support-portal-dialog',
    templateUrl: './support-portal-dialog.component.html',
    styleUrls: ['./support-portal-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatLabel]
})
export class SupraPortalDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SupraPortalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SupportPortalDialogData) { }

  /**
  * @method onCloseClick closes the dialog box
  * @returns void
  **/
  public onCloseClick(): void {
    this.dialogRef.close();
  }
}
